const EDU_PREFIX = '/edu';

/**
 * 检测当前 URL 是否处于 /edu 模式（仅生产环境生效）
 */
export function detectEduPrefix() {
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  const { pathname } = window.location;
  return pathname === EDU_PREFIX || pathname.startsWith(`${EDU_PREFIX}/`)
    ? EDU_PREFIX
    : '';
}

/** 供 VueRouter base 使用 */
export function getRouterBase() {
  if (process.env.NODE_ENV === 'development') {
    return '/';
  }
  return detectEduPrefix() || '/';
}

/**
 * 为路径添加或移除 /edu 前缀，供 Footer、静态链接等非 router 场景使用
 */
export function withRoutePrefix(path) {
  if (path && /^https?:\/\//.test(path)) {
    return path;
  }
  const prefix = detectEduPrefix();
  const normalized = path
    ? path.startsWith('/')
      ? path
      : `/${path}`
    : '';
  if (prefix) {
    if (normalized.startsWith(prefix)) {
      return normalized;
    }
    return `${prefix}${normalized}`;
  }
  if (normalized) {
    return normalized.replace(new RegExp(`^${EDU_PREFIX}`), '') || '/';
  }
  return '';
}
